import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import styled from "styled-components";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import useFocusPageStart from "../../hooks/useFocusPageStart";
import Breadcrumb from "./components/Breadcrumb/Breadcrumb";
import Sidebar from "./components/Sidebar/Sidebar";
import AboutContent from "./components/AboutContent/AboutContent";
const AboutPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f6f6f6;
`;

const HeaderWrapper = styled(SiteHeader)`
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const MainContentWrapper = styled.div`
  flex: 1;
  padding: 0;
  outline: none;
`;

const BreadcrumbWrapper = styled.div`
  z-index: 1000;
  padding: 8px 80px 16px;
  
  @media (max-width: 768px) {
    padding: 8px 16px 12px;
  }
`;

const TitleWrapper = styled.div`

  background-size: cover;
  background-position: center;
  padding: 28px 80px 18px;
  color: Black;
  @media (max-width: 768px) {
    padding: 6px 16px 14px;
  }
`;


const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 23px;
  line-height: 1.2;
  font-weight: 700;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;

  &::first-letter {
    color: #8a4b00;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 26px;
  padding: 26px 24px 48px;
  max-width: ${(props) => (props.$isOrganizationChart ? "1600px" : "1280px")};
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 992px) {
    flex-direction: column;
    padding: 20px 16px 36px;
    gap: 20px;
  }
`;

const sectionMenuItems = [
  { id: "about-nmdfc", label: "About NMDFC" },
  { id: "vision-mission", label: "Vision & Mission" },
  { id: "board-directors", label: "Board of Directors" },
  { id: "our-team", label: "Our Team" },
  { id: "organization-chart", label: "Organization Chart" },
  { id: "capital-structure", label: "Capital Structure" },
  { id: "scas-partners", label: "State Channelising Agencies(SCA)" },
  { id: "target-groups", label: "Target Groups" },
  { id: "events", label: "Media Gallery" },
];

const normalizeSection = (section) => {
  const matchedSection = sectionMenuItems.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : "about-nmdfc";
};

const AboutPage = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const [activeSection, setActiveSection] = useState(() => normalizeSection(section));

  useEffect(() => {
    setActiveSection(normalizeSection(section));
  }, [section]);

  useFocusPageStart(section || activeSection);

  const handleSelectSection = (sectionId) => {
    setActiveSection(sectionId);
    navigate(`/about/${sectionId}`);
  };

  const currentSection =
    sectionMenuItems.find((item) => item.id === activeSection) || sectionMenuItems[0];

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: currentSection.label, path: `/about/${activeSection}` },
  ];

  return (
    <AboutPageContainer>
      <HeaderWrapper>
        <BreadcrumbWrapper>
          <Breadcrumb items={breadcrumbItems} />
        </BreadcrumbWrapper>
      </HeaderWrapper>

      <MainContentWrapper id="main-content" data-readable-content tabIndex={-1}>
        <TitleWrapper>
          <PageTitle>{currentSection.label}</PageTitle>
        </TitleWrapper>

        <ContentWrapper $isOrganizationChart={activeSection === "organization-chart"}>
          <Sidebar
            activeSection={activeSection}
            onSelectSection={handleSelectSection}
            menuItems={sectionMenuItems}
          />
          <AboutContent activeSection={activeSection} />
        </ContentWrapper>
      </MainContentWrapper>

      <Footer />
    </AboutPageContainer>
  );
};

export default AboutPage;
